import { useState } from "react";
import axios from "axios";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const apiUrl = process.env.REACT_APP_MONGO_URL;

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${apiUrl}/api/auth/register`, { name, email, password });
      setSuccess(true);
      setError("");
    } catch (err) {
      setError(err.response?.data?.message || "Kayıt başarısız");
    }
  };

  return (
    <div>
      <h2>Kayıt Ol</h2>
      {success && <p style={{ color: "green" }}>Başarıyla kayıt oldunuz!</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleRegister}>
        <input type="text" placeholder="İsim" value={name} onChange={(e) => setName(e.target.value)} />
        <input type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input type="password" placeholder="Şifre" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button type="submit">Kayıt Ol</button>
      </form>
    </div>
  );
};

export default Register;
